import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <main className="bg-white min-h-screen">
      <section className="py-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-6">
            Privacy <span className="text-brand-red">Policy</span>
          </h1>

          <p className="text-gray-500 text-sm mb-10">
            Last updated: August 2026
          </p>

          <div className="space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                1. Introduction
              </h2>
              <p>
                Alakhe Conglomerate (Pty) Ltd ("Alakhe Conglomerate", "we",
                "us", or "our") respects your privacy and is committed to
                protecting the personal information you provide when using
                our website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                2. Information We Collect
              </h2>
              <p>
                When you contact us through our website, we may collect
                information such as your name, email address, telephone
                number, company details, and any information you choose to
                include in your message.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                3. How We Use Your Information
              </h2>
              <p>
                Information submitted through our website may be used to
                respond to enquiries, provide requested information, discuss
                potential projects or services, and communicate with you
                regarding your enquiry.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                4. Protection of Information
              </h2>
              <p>
                We take reasonable measures to protect personal information
                against unauthorised access, disclosure, alteration, or
                destruction. However, no method of transmission or storage
                over the internet can be guaranteed to be completely secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                5. Third-Party Services
              </h2>
              <p>
                Our website may use third-party services to provide certain
                functionality, such as communication, analytics, hosting, or
                external links. These services may process information in
                accordance with their own privacy policies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                6. Your Rights
              </h2>
              <p>
                Where applicable under South African law, you may have rights
                regarding your personal information, including the right to
                request access to, correction of, or deletion of personal
                information held by us.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                7. Contact Us
              </h2>
              <p>
                If you have questions about this Privacy Policy or how your
                personal information is handled, please contact Alakhe
                Conglomerate through the contact details provided on this
                website.
              </p>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicyPage;